export const zh = {
    location: "当前位置",
    home: "首页",
    myTasks: "我的任务",
    dashboard: "首页",
    taskTodo: "所有待办任务",
    taskTodoSFB: "质量反馈待办任务",
    taskManagement: "任务管理和查询",
    basicData: "基础数据",
    supplierData: "供应商主数据",
    supplierDataNew: "新增供应商主数据",
    carrierData: "承运商主数据",
    carrierDataNew: "新增承运商主数据",
    carrierDataEdt: "修改承运商主数据",
    materielData: "物料运输主数据",
    linePriceData: "线路报价主数据",
    materialPriceData: "物料运费价格主数据",
    arrivalWarehouse: "到货仓库",
    pickUpPoint: "提货点",
    plant: "工厂",
    quoteByLine: "按线路报价",
    lineQuotationApplication: "线路报价申请单",
    inquiryQuotationLine: "询报价(线路)",
    fixedPointLineQuotation: "线路报价确认",
    lineChange: "线路变更",
    quoteByProduct: "按产品报价",
    productQuotationApplication: "产品报价申请单",
    inquiryQuotationProduct: "询报价(产品)",
    fixedPointProductQuotation: "产品报价确认",
    todoList: "TO DO List",
    visitPlan: "年度拜访计划",
    MSV: "MSV",
    visitReportSp: "拜访报告(sp)",
    visitReport: "拜访报告",
    systemManagement: "系统管理",
    userManagement: "用户管理",
    roleManagement: "角色管理",
    functionManagement: "权限管理",
    backgroundProcessLog: "接口日志",
    categoryGroup: "Category分组",
    categoryGroupAdd: "Category分组详情",
    MSVGroup: "MSV分组",
    Cron: "定时任务",
    MSVGroupAdd: "MSV分组详情",
    ssrManage: "SSR管理",
    rfp: "RFP",
    rfpManage: "RFP 管理",
    spm: "SPM",
    spmTemplate: "评分模型维护",
    spmGenera: "评分大类维护",
    spmManage: "供应商评分管理",
    material: "物料主数据管理",
    materialMasterData: "物料主数据维护",
    materialGRI: "物料主数据GRI管理",
    materialGRIC1: "物料主数据GRI维护C1",
    materialGRIC2: "物料主数据GRI维护C2",
    qspiTodo: "QSPI待办任务",
    qspi: "QSPI",
    qspiQuery: "QSPI综合查询",
    fsqpiQuery: "FSQPI综合查询",
    qspiRating: "QSPI评分",
    qspiAAA: "AAA",
    qspiAAATemplate: "评分模板",
    qspiAAATask: "AAA评分任务",
    qspiAAASummary: "AAA评分汇总",
    activeDisposal: "主动报废",
    fsqIncidents: "FSQ Major incidents",
    qspiQBR: "QBR",
    qspiQBRPlan: "QBR计划",
    qspiStockRecovery: "Stock Recovery",
    qspiQIP: "QIP",
    qspiDQMP: "DQMP",
    qspiOther: "其他类评分",
    qspiSWA: "SCHR",
    qspiSQMS: "SQMS",
    qspiGovtCert: "Gov't Cert",
    qspiSpecCompliance: "Spec Compliance",
    qspiCOA: "COA",
    qspiRegCompliance: "Reg Compliance",
    qspiGovtPlantAudit: "Gov't Plant Audit",
    qspiOtherStockRecovery: "Stock Recovery",
    qspiProductFeedback: "Product Feedback",
    qspiSensory: "Sensory",
    qspiMSV: "MSV",
    qspiFSPI: "FSPI",
    qspiOtherQIP: "QIP",
    rmc: "RMC",
    qspiConfig: "QSPI配置",
    qspiFacility: "QSPI Facility清单",
    qspiDC: "QSPI DC清单",
    inboundQty: "收货量",
    qspiFacilityOutbound: "DC月度各Facility发货量",
    qspiDCOutbound: "DC发货量(RMC月度)",
    qspiGC: "GC(月度)",
    qspiDCInbound: "DC月度收货量",
    qspiAntiChick: "Antibiotic Chicken",
    rmcProduce: "RMC-Produce",
    rmcProdFarmGroup: "Farm Group",
    rmcProdScore: "RMC评分",
    rmcProdPcQty: "采购量",
    rmcProdFarm: "农场清单",
    rmcProdAuditor: "审核员清单",
    rmcProdMedicine: "药品清单",
    rmcProdMedUsage: "药品用量",

    rmcProtein: "RMC-Protein",
    rmcProtASL: "ASL主数据",
    rmcProtScore: "RMC评分",
    rmcProtPcQty: "采购量",
    rmcProtFarm: "农场清单",
    rmcProtFeedPlant: "饲料厂清单",
    rmcProtAuditor: "审核员清单",
    rmcProtMedicine: "药品清单",
    rmcProtMedUsage: "药品用量",
    rmcProt3P: "ASL审核报告",
    qspiReport: "QSPI报表",
    qspiPerformance: "Performance 报表",
    qspiOverallPerformance: "Overall Performance 报表",
    qspiMonthlyAnalysis: "Monthly Analysis 报表",
    qspiOtherQBR: "QBR",
    nutritionManagement: "Nutrition管理",
    nutritionIngredient: "Ingredient主数据",
    nutritionInspect: "Nutrition检测",
    nutritionReport: "GRI Nutrition Analysis",
    nutritionAnalysis: "Menu Nutrition Analysis",
    nutritionBasicData: "Nutrition基础数据",
    nutritionDeliveryRatio: "供货比重",
    nutritionConfiguration: "Nutrition配置",
    nutritionInspectWindow: "检测窗口期配置",
    nutritionInspectTemplateConfiguration: "检测模板配置",
    nutritionTodo: "Nutrition待办任务",
    dataDictionaryConfig: "数据字典配置",
    post: "岗位管理",
    procProcess: "制成管理",
    procProcessManage: "制成基础管理",
    procFactorManage: "制成指标管理",
    procProcedureMonitor: "生产过程监控",
    procTpl: "制成收集模版",
    procLotRecord: "制成收集记录(小批次)",
    procLotRecordDetail: "制成收集记录(小批次)/详情",
    procBatchRecord: "制成收集记录(大批次)",
    procBatchRecordDetail: "制成收集记录(大批次)/详情",
    procTplDetail: "制成收集模版详情",
    procDataDistChart: "制成数据分布图",
};

export const en = {
    location: "current location",
    home: "Home",
    myTasks: "My Tasks",
    taskTodo: "Task to do",
    taskManagement: "Task Management",
    basicData: "Basic data",
    supplierData: "Supplier master data",
    supplierDataNew: "New suplier master data",
    carrierData: "Carrier master data",
    carrierDataNew: "New carrier master data",
    carrierDataEdt: "Modify carrier master data",
    materielData: "Materiel master data",
    linePriceData: "Line price master data",
    materialPriceData: "Material freight price master data",
    arrivalWarehouse: "Arrival warehouse (DC)",
    pickUpPoint: "Pick up point",
    plant: "Plant",
    quoteByLine: "Quote by line",
    lineQuotationApplication: "Line quotation application form",
    inquiryQuotationLine: "Inquiry and quotation (line)",
    fixedPointLineQuotation: "Fixed point of line quotation",
    lineChange: "Line change",
    quoteByProduct: "Quote by product",
    productQuotationApplication: "Product quotation application",
    inquiryQuotationProduct: "Inquiry and quotation (product)",
    fixedPointProductQuotation: "Fixed point of product quotation",
    todoList: "TO DO List",
    visitPlan: "Visit Plan",
    MSV: "MSV",
    visitReportSp: "Visit Report(sp)",
    visitReport: "Visit Report",
    systemManagement: "System management",
    userManagement: "User management",
    roleManagement: "Role management",
    functionManagement: "Privilege management",
    backgroundProcessLog: "Background process log",
    categoryGroup: "Category Group",
    MSVGroup: "MSV Group",
    ssr: "SSR",
    ssrManage: "SSR Manage",
    rfp: "RFP",
    rfpManage: "RFP Manage",
    spm: "SPM",
    spmTemplate: "SPM Template",
    spmGenera: "SPM Genera",
    spmManage: "SPM Management",
    material: "material",
    materialMasterData: "Material Master Data",
    materialGRI: "materialGRI",
    materialGRIC1: "materialGRIC1",
    materialGRIC2: "materialGRIC2",
    qspi: "QSPI",
    rmc: "RMC",
    qspiReport: "QSPI报表",
    post: "岗位管理"

};